import { Component, OnInit } from '@angular/core';
import { SnackbarComponent } from '../snackbar/snackbar.component';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { MyUtils } from 'src/app/services/my-utils.service';

@Component({
  selector: 'app-snackbar-brand-error',
  templateUrl: './snackbar-brand-error.component.html',
  styleUrls: ['./snackbar-brand-error.component.scss']
})
export class SnackbarBrandErrorComponent implements OnInit {

  ngOnInit(): void {}
  constructor(public snackBarRef: MatSnackBarRef<SnackbarComponent> , public utils: MyUtils) {}

}
